import { createSlice } from "@reduxjs/toolkit";

const initialRelatorioSkus = {
  params: {
    page: 1,
    sort_by: 'total',
    sort_direction: 'desc',
  },
  filters: {
    limit: 20,
  },
  showDivergent: false,
};

const date = new Date();
const pad = n => String(n).padStart(2, "0");
const firstDay = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-01`;
const currentDay = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const initialState = () => {
  return {
    ...initialRelatorioSkus,
    issueDateStart: firstDay,
    issueDateEnd: currentDay,
  };
};

export const relatorioSkusSlice = createSlice({
  name: "relatorioSkus",
  initialState,
  reducers: {
    handleChangeDate: (state, { payload }) => {
      state.issueDateStart = payload.issueDateStart;
      state.issueDateEnd = payload.issueDateEnd;
    },
    handleRowLimit: (state, { payload }) => {
      state.params.limit = payload;
    },
    handleParams: (state, { payload }) => {
      const field = payload?.field;
      state.params[field] = payload?.value;
      return state;
    },
    handleFilterParams: (state, { payload }) => {
      const field = payload?.field;
      state.params[field] = payload?.value;
      return state;
    },
    handleCleanFilterParams: (state, { payload }) => {
      delete state.filters.nome;
      delete state.filters.nome_tipo;
      delete state.filters.cod_produto;
      state.filters.limit = payload.limit;
      return state;
    },
    handleAddFilter: (state, { payload }) => {
      state.filters = payload;
      state.params.page = 1;
    },
    handleShowType: (state, { payload }) => {
      state.showDivergent = payload;
    },
    handleSort: (state, { payload }) => {
      state.params.sort_by = payload.sort_by;
      state.params.sort_direction = payload.sort_direction;
      state.params.page = 1;
    },
  },
});

export const {
  handleChangeDate,
  handleRowLimit,
  handleParams,
  handleFilterParams,
  handleCleanFilterParams,
  handleAddFilter,
  handleShowType,
  handleSort,
} = relatorioSkusSlice.actions;

export default relatorioSkusSlice.reducer;
